// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .grouped3 {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .KOheader {
    font-size: 28px;
  }
  .paragraph {
    font-size: 18px;
  }
  #pastorPic{
    height: 500px;
  }
  .dividers{
    flex-direction: column;
    display: flex;
  }
  .dividers .MessageBox, .dividers #homeVerse{
    width: 100%;
  }
  .fade{
    max-width: 100%;
  }
}

.container {
  position: relative;
  width: 80%;
  margin: 0 auto;
}
#theChurch{
  display: block;
  width: 100%;
  height: auto;
  max-height: 700px;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  background: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.5); /* see through color */
  color: #f1f1f1;
  transition: .5s ease;
  opacity:0;
  color: white;
  font-size: 30px;
  padding: 20px;
  text-align: center;
}
.container:hover .overlay {
  opacity: 1;
}

.picBorder{
  border: 10px solid #555;
}

.grouped3{
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

/* For image transitions */
.fade{
    animation: fade 7s infinite;
}
@keyframes fade {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}
.infoHeader{
  color: gray;
  font-size: large;
  font-weight: bold;
  font-size: 18px;
}
.KOheader{
  font-size: 40px;
  margin-bottom: -10px;
}
.MessageBox{
  width: 40%;
}
#homeVerse{
  width: 40%;
  font-size: 30px;
  font-style: italic;
  background-color: antiquewhite;
}
.paragraph{
  font-size: 28px;
}
#Message{
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Home.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;;EAER,wBAAwB;EACxB,8BAA8B,EAAE,sBAAsB;EACtD,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;IACI,2BAA2B;AAC/B;AACA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB","sourcesContent":["@media (max-width: 768px) {\n  .grouped3 {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n  .KOheader {\n    font-size: 28px;\n  }\n  .paragraph {\n    font-size: 18px;\n  }\n  #pastorPic{\n    height: 500px;\n  }\n  .dividers{\n    flex-direction: column;\n    display: flex;\n  }\n  .dividers .MessageBox, .dividers #homeVerse{\n    width: 100%;\n  }\n  .fade{\n    max-width: 100%;\n  }\n}\n\n.container {\n  position: relative;\n  width: 80%;\n  margin: 0 auto;\n}\n#theChurch{\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 700px;\n}\n.overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n\n  background: rgb(0, 0, 0);\n  background: rgba(0, 0, 0, 0.5); /* see through color */\n  color: #f1f1f1;\n  transition: .5s ease;\n  opacity:0;\n  color: white;\n  font-size: 30px;\n  padding: 20px;\n  text-align: center;\n}\n.container:hover .overlay {\n  opacity: 1;\n}\n\n.picBorder{\n  border: 10px solid #555;\n}\n\n.grouped3{\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 20px;\n}\n\n/* For image transitions */\n.fade{\n    animation: fade 7s infinite;\n}\n@keyframes fade {\n  0% { opacity: 0; }\n  50% { opacity: 1; }\n  100% { opacity: 0; }\n}\n.infoHeader{\n  color: gray;\n  font-size: large;\n  font-weight: bold;\n  font-size: 18px;\n}\n.KOheader{\n  font-size: 40px;\n  margin-bottom: -10px;\n}\n.MessageBox{\n  width: 40%;\n}\n#homeVerse{\n  width: 40%;\n  font-size: 30px;\n  font-style: italic;\n  background-color: antiquewhite;\n}\n.paragraph{\n  font-size: 28px;\n}\n#Message{\n  font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
